import './style.css';
import { useEffect } from 'react';
import useUsersStore from 'store/users';
import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { Tabs, Tab } from '@thermon-platforms/thermon-ui-core';

import ResetPassword from './reset-password';
import PersonalInformation from './personal-information';


function MyAccount() {
  const { _ } = useLingui();
  const [usersStore, usersStoreActions] = useUsersStore();

  useEffect(() => {
    usersStoreActions.query();
  }, []);

  return (
    <div className="view my-profile">
      <header>
        <h2><Trans>My Account</Trans></h2>
      </header>
      <section>
        <Tabs useNav={true}>
          <Tab name={_(msg`Personal Information`)}>
            <PersonalInformation user={usersStore.currentUser} />
          </Tab>
          <Tab name={_(msg`Reset Password`)}>
            <ResetPassword user={usersStore.currentUser} />
          </Tab>
        </Tabs>
      </section>
    </div>
  );
}

export default MyAccount;
